import { SvgIcon, type SvgIconProps } from '@mui/material';
import './icons.css';

export const LoadingIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox={'-4 -4 28 28'} sx={{ fontSize: '48px' }}>
      <path d="M22.819,20.415l-20.563,-0c-0.254,-0 -0.461,-0.207 -0.461,-0.461l0,-0.922c0,-0.254 0.207,-0.461 0.461,-0.461l4.46,-0l3.837,-14.323l0.83,0.223l1.019,-0.273l3.852,14.373l0.938,-0l-0,-4.061c-0,-0.047 0.019,-0.093 0.053,-0.127c0.033,-0.034 0.079,-0.053 0.127,-0.053l5.449,0c0.099,0 0.179,0.08 0.179,0.179l0,5.725c-0,0.1 -0.081,0.181 -0.181,0.181Zm-14.194,-1.844l5.72,-0l-2.86,-10.674l-2.86,10.674Z" />
      <path
        className="loading-pumpjack-animation"
        d="M4.49,5.568l-0,2.753c-0,0.238 -0.095,0.467 -0.263,0.635c-0.169,0.169 -0.397,0.263 -0.636,0.263l-1.344,0c-1.241,0 -2.247,-1.005 -2.247,-2.246l0,-4.724c-0,-0.596 0.237,-1.169 0.659,-1.59c0.421,-0.422 0.994,-0.659 1.59,-0.659l1.338,0c0.24,0 0.469,0.095 0.638,0.264c0.17,0.17 0.265,0.399 0.265,0.638l-0,2.822l18.036,-0c0.255,-0 0.461,0.206 0.461,0.461l0,0.922c0,0.254 -0.206,0.461 -0.461,0.461l-18.036,-0Z"
      ></path>
    </SvgIcon>
  );
};
